export enum UNIT {
  EURO = ' €',
  PERCENT = ' %',
  NONE = '',
}
